import { useSelector } from 'react-redux'

import { selectSendTo } from '../redux/sendTo'

export default function useSendTo() {
  const { data, isLoading, error } = useSelector(selectSendTo)

  return {
    data,
    error,
    isLoading,
  }
}
